import angular from 'angular';

import ToastItem from './toast-item/toast-item.component';
import ToastService from './toast.service';
import ToastWrap from './toast-wrap/toast-wrap.component';

export default angular.module('components.toast', [
  ToastItem,
  ToastService,
  ToastWrap,
])
  .name;
